module.exports = __webpack_public_path__ + "static/img/bg4.6d0681f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg4.png
// module id = 239
// module chunks = 1